import React from 'react'
import { AiFillYoutube } from 'react-icons/ai'
import HeaderPage from '../../components/headerpage/HeaderPage'
import useAppContext from '../../hook/useAppContext'
import Empty from '../../components/empty/Empty'
import './videos.css'

const Videos = ({current}) => {

      const {user} = useAppContext()
      const {videos} = user 

      if(current !== 'videos') return 

      if(videos.code){
            return (
                  <Empty title={"Videos"} desc={"Oops, it seems there are no videos available for display yet."}/>
            )
      }
      
      return (
            <div className="page_group">
                  <HeaderPage desc={`Playlist Youtube`} />
                  <div className="wrapper_video__group">
                        {
                              videos.map((item, index) => (
                                    <div className="video_row" key={index}>
                                          <div className="video_youtube__box">
                                                <iframe width="100%" height="100%" src={`https://www.youtube.com/embed/${item.id_video}?si=vBuPfvDG0ePSpEXv`} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
                                          </div>
                                          <div className="video_description flex">
                                                <div className="video_icon flex">
                                                      <AiFillYoutube />
                                                </div>
                                                <div className="video_title">
                                                      <p>{item.title}</p>
                                                </div>
                                          </div>
                                    </div>
                              ))
                        }
                        
                  </div>
            </div>
      )
}

export default Videos
